import type { CompareBlock, CompareSide } from "../contract/types";
import { Icon } from "../components/Icon";
import type { BlockViewProps } from "./types";

/**
 * Dos posturas enfrentadas: VAN vs TIR, costo de oportunidad vs costo de
 * capital. Las dos columnas se leen en espejo y el veredicto resuelve —el
 * veredicto es la razón de ser del bloque— así que va destacado y separado.
 */

function Side({ side, tone }: { side: CompareSide; tone: "left" | "right" }) {
  return (
    <section className={`compare__side compare__side--${tone}`}>
      <header className="compare__head">
        <h4 className="compare__title">{side.title}</h4>
        {side.subtitle ? <p className="compare__subtitle">{side.subtitle}</p> : null}
      </header>
      <ul className="compare__items">
        {(side.items ?? []).map((item, index) => (
          <li key={`${item.label}-${index}`} className="compare__item">
            <span className="compare__item-label">{item.label}</span>
            {item.detail ? <span className="compare__item-detail">{item.detail}</span> : null}
          </li>
        ))}
      </ul>
    </section>
  );
}

export function Compare({ block }: BlockViewProps<CompareBlock>) {
  return (
    <div className="atom atom--compare compare">
      <div className="compare__grid">
        <Side side={block.left} tone="left" />
        <div className="compare__divider" aria-hidden="true">
          <span className="compare__versus">frente a</span>
        </div>
        <Side side={block.right} tone="right" />
      </div>
      {block.verdict ? (
        <footer className="compare__verdict">
          <span className="compare__verdict-label">
            <Icon name="scale" size="0.875rem" />
            Veredicto
          </span>
          <p className="compare__verdict-text">{block.verdict}</p>
        </footer>
      ) : null}
    </div>
  );
}

export default Compare;
